export default [
    {
        name: 'Comunicação',
        options: [
            {
                id: 15604,
                label: 'Comunicação',
                name: 'Observação',
            },
            {
                id: 15605,
                label: 'Comunicação',
                name: 'Lembrete',
            },
            {
                id: 15606,
                label: 'Comunicação',
                name: 'Melhoria',
            },
            {
                id: 15608,
                label: 'Comunicação',
                name: 'Projeto',
            },
        ],
    },
    {
        name: 'Ação',
        options: [
            {
                id: 15609,
                label: 'Ação',
                name: 'Executar',
            },
            {
                id: 15610,
                label: 'Ação',
                name: 'Reparar',
            },
            {
                id: 15611,
                label: 'Ação',
                name: 'Organizar',
            },
        ],
    },
]
